import { useCallback } from 'react';
import { splitPostalCodeAndCity } from '../utils/formatting';
import { useAddressService } from './useAddressService';

type FetchCitySuggestionsProps = {
  countryISO?: string;
  limit: number;
};

export function useFetchCitySuggestions({
  countryISO,
  limit,
}: FetchCitySuggestionsProps): (searchTerm: string) => Promise<string[]> {
  const { addressService } = useAddressService();
  return useCallback(
    async (searchTerm: string) => {
      if (!countryISO) return [];
      const { postalCode, city } = splitPostalCodeAndCity(searchTerm);
      const result = await addressService.autoCompleteCities({
        countryISO,
        limit,
        key: postalCode !== '' ? postalCode : city,
      });
      return result.Cities.map((city) => `${city.PostalCode} ${city.Name}`);
    },
    [countryISO, limit, addressService]
  );
}
